<template>
    <button 
        class="btn btn-link m-0 p-0 bg-white border-0" 
        type="button" 
        v-clipboard:copy="url"
        :aria-label="ariaLabelProp"
        ref="button">
        <slot />
    </button>
</template>

<script>
    export default {
        data() {
            return {
                url: window.location.href
            }
        },
        props: {
            ariaLabelProp: {
                type: String,
                default: 'Copy site URL to your clipboard.'
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/app/components/aha-copy-url-to-clipboard.vue